import { SeatMapCabinRowSectionElement } from "@duffel/api/types";

export function isAmenityElement(element: SeatMapCabinRowSectionElement) {
  return (
    element.type === "bassinet" ||
    element.type === "lavatory" ||
    element.type === "closet" ||
    element.type === "galley" ||
    element.type === "stairs"
  );
}
;
import "/Users/andrejakogovsek/.yarn/berry/cache/@sentry-bundler-plugin-core-npm-0.7.2-054e3436fd-10c0.zip/node_modules/@sentry/bundler-plugin-core/sentry-release-injection-file.js";